import React, {Suspense} from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import SurveyPage from './SurveyPage';
import SubmitSurveyMutation from '../../mutation/SubmitSurveyMutation';

class LeadSurvey extends React.Component {

  constructor(props) {
    super(props);
  }

  onSubmit(fields = []) {
    let {
      viewer = {}
    } = this.props;

    let {
      leadSurvey = {},
    } = viewer;

    let answers = [];
    fields.forEach(field => {
      let fieldId = field.fieldId;
      let value = field.value;
      if (Array.isArray(value)) {
        value.forEach(v => {
          answers.push({
            id: fieldId,
            answerId: +v,
          })
        })
      } else {
        answers.push({
          id: fieldId,
          answerId: +value,
        })
      }
    });

    let data = {
      leadType: 'INQUIRY_PRODUCT',
      relatedIds: ['0005db98ddc6cc51c7d533e604b777aea47ce858'],
      answer: {
        id: +leadSurvey.plainId,
        answers: answers,
      }
    }

    return SubmitSurveyMutation(
      this.props.relay.environment,
      data
    )
  }

  render() {
    let {
      viewer = {}
    } = this.props;

    let {
      leadSurvey = {},
    } = viewer;

    if (leadSurvey == null) leadSurvey = {};

    let {
      title,
      pages = [],
    } = leadSurvey;

    return (
      <div>
        <h3>{title}</h3>
        {pages.map((page, index) => {
          return (
            <SurveyPage surveyPage={page} key={index} onSubmit={::this.onSubmit} />
          )
        })}
      </div>
    );
  }

}

export default createRefetchContainer(
  LeadSurvey,
  {
    viewer: graphql`
        fragment LeadSurvey_viewer on Viewer
        @argumentDefinitions(
            leadType: {type: "String"},
        ),
        {
            leadSurvey(leadType: $leadType) {
                id
                plainId
                title
                description
                pages {
                    id
                    plainId
                    title
                    description
                    displayOrder
                    items {
                        id
                        plainId
                        title
                        description
                        displayOrder
                        type
                        answerRequired
                        answers {
                            id
                            plainId
                            displayOrder
                            type
                            dataType
                            title
                        }
                        otherAnswerAdd
                        otherAnswerDisplayType
                        otherAnswer {
                            id
                            plainId
                            type
                            dataType
                            title
                        }
                    }
                }
            }

        }
    `
  },
  graphql`
      query LeadSurveyRefetchQuery($leadType:String) {
          viewer {
              ...LeadSurvey_viewer @arguments(leadType: $leadType)  
          }
      }
  `
);
